module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LSO BY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRIS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKOWSKI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Decisions at Fredericksburg: The Fourteen Critical Decisions that Defined the Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Grant’s Last Battle: The Story Behind the Personal Memoirs of Ulysses S. Grant")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Battle Never Fought: The Mine Run Campaign, November 26-December 2, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hell Itself: The Battle of the Wilderness, May 5-7, 1864")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Strike Them a Blow: Battle Along the North Anna River, May 21-25, 1864")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Traces of the Bloody Struggle: The Civil War at Stevenson Ridge, Spotsylvania Court House")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chancellorsville’s Forgotten Front: The Battles of Second Fredericksburg and Salem Church, May 3, 1863")]), _vm._v(" (with Kristopher D. White)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t Give an Inch: The Second Day at Gettysburg, July 2, 1863—From Little Round Top to Cemetery Ridge")]), _vm._v(" (with Kristopher D. White and Daniel T. Davis)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fight Like the Devil: The First Day at Gettysburg, July 1, 1863")]), _vm._v(" (with Kristopher D. White and Daniel T. Davis)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Days of Stonewall Jackson: The Mortal Wounding of the Confederacy’s Greatest Icon")]), _vm._v(" (with Kristopher D. White)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Season of Slaughter: The Battle of Spotsylvania Court House, May 8-21, 1864")]), _vm._v(" (with Kristopher D. White)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Seizing Destiny: The Army of the Potomac’s “ Valley Forge” and the Civil War Winter that Saved the Union")]), _vm._v(" (with Albert Z. Conner, Jr.)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Simply Murder: The Battle of Fredericksburg, December 13, 1862")]), _vm._v(" (with Kristopher D. White)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That Furious Struggle: Chancellorsville and the High Tide of the Confederacy, May 1-4, 1863")]), _vm._v(" (with Kristopher D. White)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fac3696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Also.vue
// module id = 60
// module chunks = 0